module.exports = __webpack_public_path__ + "static/og-image-aufwand-7b3c1758b1eb125549c73ecf322a5ea6.png";